var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.385,
    height: 18.385,
    viewBox: "0 0 18.385 18.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(9.192 -13.435) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7349",
    "data-name": "Trazado 7349",
    d: "M12,6V26",
    transform: "translate(4)",
    fill: "none",
    stroke: "#33363f",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7350",
    "data-name": "Trazado 7350",
    d: "M26,12H6",
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#33363f",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.89a656638f78c8e51a2a8d131a0961d4.svg";
export { ForwardRef as ReactComponent };